import styled from '@emotion/styled';
import { themeColors } from '../../../constants/themes';
import { fontSize } from '../../../constants/theme';

export const ContentRow = styled.div`
  display: flex;
  justify-content: ${({justifyContent}) => justifyContent || 'center'};
  align-items: center;
  ${({noMargin}) => noMargin ? '' : 'margin: 16px 0;'}
  ${({height}) => height && `height: ${height};`}
  ${({width}) => width && `width: ${width};`}
`;

export const TableTitle = styled.span`
  font-family: Heebo;
  font-size: ${fontSize.small};
  font-weight: 500;
  line-height: 2.33;
  text-align: left;
  color: ${themeColors.darkBlue};
`;
